import { ReactNode } from "react";
import { t } from "@lingui/core/macro";

import { Button } from "_/components/button";
import { ButtonContainer } from "_/components/modal";

import * as S from "./styled";

/**
 * Shows a link that an admin must hand to a user directly, because this
 * install cannot send email.
 */
export const HandoffLink = ({
  description,
  link,
  footnote,
  onClose,
}: {
  description: ReactNode;
  link: string;
  footnote?: ReactNode;
  onClose: () => void;
}) => (
  <S.Container>
    <p>{description}</p>
    <S.Link>{link}</S.Link>
    {footnote && <S.Footnote>{footnote}</S.Footnote>}
    <ButtonContainer>
      <Button type="button" onClick={onClose}>
        {t`common.ok`}
      </Button>
    </ButtonContainer>
  </S.Container>
);
